import { Grid } from '@domain-group/suit-theme'

import { ImageModel } from '@models/types'

import ImageGridItem from '../../ImageGridItem'

type GridViewProps = {
  images: ImageModel[],
}

const GridView = (props: GridViewProps) => {
  const { images } = props

  return (
    <Grid
      // @ts-expect-error TS2322
      gridColumnGap="medium"
      gridRowGap="large"
      gridAutoRows="1fr"
      gridTemplateColumns="repeat(2, 1fr)"
      marginTop="large"
      padding={0}
    >
      {images.map(image => <ImageGridItem image={image} key={image.id} />)}
    </Grid>
  )
}

export default GridView
